import { useEffect, useState } from 'react';
import api, { AuditRow } from '../services/api';
import { errMsg } from '../utils';

export default function AuditPage() {
  const [rows, setRows] = useState<AuditRow[]>([]);
  const [actionFilter, setActionFilter] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    setError('');
    try {
      const r = await api.get<AuditRow[]>('/audit', {
        params: actionFilter ? { action: actionFilter } : {},
      });
      setRows(r.data);
    } catch (e) {
      setError(errMsg(e));
    }
  };

  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadCsv = async () => {
    setError('');
    try {
      const r = await api.get('/reports/entitlements.csv', { responseType: 'blob' });
      const url = URL.createObjectURL(r.data as Blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'entitlements.csv';
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      setError(errMsg(e));
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-white">Audit &amp; Reports</h2>
        <button className="btn-primary" onClick={downloadCsv}>
          Entitlement-Report (CSV)
        </button>
      </div>
      {error && <p className="text-coral">{error}</p>}

      <section className="card flex items-end gap-3">
        <div className="flex-1">
          <label className="label">Filter nach Action</label>
          <input
            className="input"
            placeholder="z. B. lifecycle.leaver"
            value={actionFilter}
            onChange={(e) => setActionFilter(e.target.value)}
          />
        </div>
        <button className="btn-ghost" onClick={load}>
          Anwenden
        </button>
      </section>

      <section className="card overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-edge">
              <th className="th">Zeit</th>
              <th className="th">Akteur</th>
              <th className="th">Action</th>
              <th className="th">Ziel-User</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-edge/50">
                <td className="td whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                <td className="td">{r.actor_email || r.actor_sub}</td>
                <td className="td">{r.action}</td>
                <td className="td">{r.target_user_id ?? '—'}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td className="td text-gray-500" colSpan={4}>
                  Keine Audit-Einträge.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
}
